import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";
import { trackCallConversion } from "@/lib/analytics";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3">
      <a
        href={`https://wa.me/${COMPANY.whatsapp}?text=Hi%20StoneCrest,%20I'd%20like%20a%20free%20quote`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-button"
        aria-label="WhatsApp us"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle className="w-7 h-7" fill="white" />
      </a>
      <a
        href={COMPANY.phoneHref}
        onClick={trackCallConversion}
        data-testid="floating-call-button"
        aria-label="Call us"
        className="w-14 h-14 rounded-full bg-[var(--oxblood)] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 md:hidden"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
